import {useMsal} from '@azure/msal-react'
import {useOverlayPreloader} from '../../../../hooks/use-overlay-preloader'
import React from 'react'
import {msalRequest} from '../../../../env-config'
import { useNavigate } from 'react-router-dom'

export const useMenuForNotAuthenticated = (closeDrawer: () => void) => {
  const { instance } = useMsal()
  const { setIsShowOverlayPreloader } = useOverlayPreloader()

  const navigate = useNavigate();

  const onDonateClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    setIsShowOverlayPreloader(true)
    instance
      .loginRedirect({
        ...msalRequest,
        redirectUri: '/',
        state: '/donate',
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          console.log(error)
        }
      })
    closeDrawer()
  }
    const onSearchClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
      e.preventDefault()
      navigate("/search")
    }

  return {
    onDonateClickHandler,
    onSearchClickHandler,
    closeDrawer
  }
}
